import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ExceptionalDateList from 'components/Lists/ExceptionalDateList'
import CreateExceptionalDateModal from 'pages/Modals/CreateExceptionalDateModal'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'
import { Container, Row } from '../../styles'

export default function EditExceptionalDates () {
  const [loading, setLoading] = useState (true)
  const [exceptionalDates, setExceptionalDates] = useState ([])
  const [showCreateExceptionalDateModal, setShowCreateExceptionalDateModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      setLoading (true)
      const { data: exceptionalDates } = await cutileiApi.get (
        `/businesses/${businessId}/exceptional_dates`,
        requestConfig
      )
      setExceptionalDates (exceptionalDates)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const compareExceptionalDates = (a, b) => (
    DateTime.fromISO (a.start_date).toMillis () - DateTime.fromISO (b.start_date).toMillis ()
  )

  const handleCreateExceptionalDate = exceptionalDate => {
    setExceptionalDates (prev => [...prev, exceptionalDate].sort (compareExceptionalDates))
  }

  const handleEditExceptionalDate = exceptionalDate => {
    setExceptionalDates (prev => prev.map (e => e.id === exceptionalDate.id ? {...exceptionalDate} : e))
  }

  const handleDeleteExceptionalDate = exceptionalDate => {
    setExceptionalDates (prev => prev.filter (e => e.id !== exceptionalDate.id))
  }

  const toggleCreateExceptionalDateModal = () => (
    setShowCreateExceptionalDateModal (!showCreateExceptionalDateModal)
  )

  if (loading) return <Loading style={{marginTop: 30}}/>

  return (
    <Container style={{paddingTop: 10}}>
      {AuthService.hasPermission ('business_config.agenda', 'edit') && (
        <Row>
          <SecondaryButton
            label='Criar data excepcional'
            onClick={toggleCreateExceptionalDateModal}
            width={180}
          />
          <CreateExceptionalDateModal
            visible={showCreateExceptionalDateModal}
            onClose={toggleCreateExceptionalDateModal}
            onConfirm={handleCreateExceptionalDate}
          />
        </Row>
      )}
      {loading ? <Loading/> : (
        <ExceptionalDateList
          exceptionalDates={exceptionalDates}
          onEdit={handleEditExceptionalDate}
          onDelete={handleDeleteExceptionalDate}
        />
      )}
    </Container>
  )
}
